const lamesRideaux = [
  {
    id: "moteur-rideau-central-di-400kg",
    title: "Moteur Rideau Central Di 400kg",
    image: "/assets/images/products/Moteur Rideau Central Di 400kg.webp",
    description: "Moteur de rideau métallique puissant et fiable pour usage commercial",
    longDescription: "Le moteur de rideau métallique ELDINO de la série RAPTOR, est caractérisé par sa fiabilité et sa robustesse. Il est conçu pour un fonctionnement facile et pratique et il est disponible en différentes tailles et puissances pour s′adapter aux différents poids et tailles. Avec son mouvement fluide et silencieux, ELDINO RAPTOR assure que vos rideaux métalliques fonctionnent efficacement pour améliorer la sécurité de votre propriété ou pour profiter du confort des rideaux métalliques. Le moteur est également facile à installer et à entretenir, ce qui en fait une solution pratique pour les propriétés résidentielles et commerciales.\nAvec sa fiabilité, sa durabilité et sa facilité d′utilisation, ELDINO RAPTOR est le choix parfait pour toute personne recherchant un moteur de rideaux métalliques efficace et fonctionnel.",
    category: "lames_rideaux",
    specifications: [
      "Capacité: 400 kg",
      "Type: Central à double induit",
      "Mouvement fluide et silencieux",
      "Installation facile",
      "Idéal pour usage commercial et industriel"
    ]
  },
  {
    id: "moteur-rideau-eldino-200kg",
    title: "Moteur Rideau Eldino 200 Kg Simple Induit Axe 60",
    image: "/assets/images/products/Moteur Rideau Eldino 200 Kg Simple Induit Axe 60.webp",
    description: "Moteur de rideau métallique compact et efficace pour usage résidentiel et commercial",
    longDescription: "Le moteur de rideau métallique ELDINO de la série RAPTOR, est caractérisé par sa fiabilité et sa robustesse. Il est conçu pour un fonctionnement facile et pratique et il est disponible en différentes tailles et puissances pour s'adapter aux différents poids et tailles. Avec son mouvement fluide et silencieux, ELDINO RAPTOR assure que vos rideaux métalliques fonctionnent efficacement pour améliorer la sécurité de votre propriété ou pour profiter du confort des rideaux métalliques. Le moteur est également facile à installer et à entretenir, ce qui en fait une solution pratique pour les propriétés résidentielles et commerciales.\nAvec sa fiabilité, sa durabilité et sa facilité d'utilisation, ELDINO RAPTOR est le choix parfait pour toute personne recherchant un moteur de rideaux métalliques efficace et fonctionnel.\n\n![Illustration du moteur](https://www.samfi.tn/media/userfiles/files/image(372).png)",
    category: "lames_rideaux",
    specifications: [
      "Capacité: 200 kg",
      "Type: Simple induit",
      "Diamètre d'axe: 60 mm",
      "Mouvement fluide et silencieux",
      "Facile à installer et à entretenir"
    ]
  },
  {
    id: "boite-rideaux",
    title: "Boite Rideaux",
    image: "/assets/images/products/Boite Rideaux.webp",
    description: "Caisson de protection pour mécanisme de rideau métallique",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de boites rideaux avec les spécifications suivantes.",
    category: "lames_rideaux",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Tôle galvanisée ou laquée de forte épaisseur",
      "Système de fixation robuste",
      "Accès pour maintenance",
      "Options: isolation phonique, trappe de visite"
    ]
  },
  {
    id: "flasque",
    title: "Flasque",
    image: "/assets/images/products/Flasque.webp",
    description: "Support latéral pour axe d'enroulement de rideau métallique",
    longDescription: "Disponibles en différentes épaisseurs de 2mm 350350 à 3mm 400400.",
    category: "lames_rideaux",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Épaisseur: 2mm 350350 à 3mm 400400",
      "Paliers auto-lubrifiants intégrés",
      "Multiples points de fixation",
      "Compatible avec différents systèmes de motorisation"
    ]
  },
  {
    id: "glissiere",
    title: "Glissière",
    image: "/assets/images/products/Glissière.webp",
    description: "Rail de guidage latéral pour lames de rideau métallique",
    longDescription: "Disponibles en différentes épaisseurs de 40/25 12/10 à 50/30 15/10.",
    category: "lames_rideaux",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Épaisseur: de 40/25 12/10 à 50/30 15/10",
      "Formes en U, G ou renforcées selon application",
      "Joints d'étanchéité disponibles",
      "Perforations préparées pour fixation murale"
    ]
  },
  {
    id: "guide-portail",
    title: "Guide Portail",
    image: "/assets/images/products/Guide Portail.webp",
    description: "Système de guidage au sol pour portails coulissants",
    longDescription: "Disponibles en 146, 220, 350.",
    category: "lames_rideaux",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Dimensions disponibles: 146, 220, 350",
      "Roulements à billes haute résistance",
      "Réglable en hauteur et largeur",
      "Compatible avec différentes épaisseurs de portail"
    ]
  },
  {
    id: "lame-finale",
    title: "Lame finale",
    image: "/assets/images/products/Lame finale.webp",
    description: "Profilé de renfort pour le bas du rideau métallique",
    longDescription: "Disponibles en différentes épaisseurs de 1.2mm à 1.5mm.",
    category: "lames_rideaux",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Épaisseur: 1.2mm à 1.5mm",
      "Joint d'étanchéité inférieur disponible",
      "Système anti-soulèvement intégrable",
      "Compatible avec différents types de serrures"
    ]
  },
  {
    id: "lame-perforee",
    title: "Lame perforée",
    image: "/assets/images/products/Lame perforée.webp",
    description: "Lame de rideau avec perforations pour ventilation et visibilité",
    longDescription: "Disponibles en différentes épaisseurs (115mm) 0.8 et 1mm, (110mm et 125mm) 0.8 et 1mm.",
    category: "lames_rideaux",
    specifications: [
      "Pour toute demande de personnalisation, consulter l'équipe technico-commerciale",
      "Épaisseur: (115mm) 0.8 et 1mm, (110mm et 125mm) 0.8 et 1mm",
      "Perforations régulières optimisées",
      "Compatible avec l'ensemble des systèmes de rideau",
      "Finitions personnalisables"
    ]
  },
  {
    id: "lame-rideau-bombee",
    title: "Lame rideau bombée type C",
    image: "/assets/images/products/Lame rideau bombée type C.webp",
    description: "Lame galbée pour rideaux métalliques enroulables",
    longDescription: "Disponibles en (115 mm) épaisseur 0.7, 0.8 et 1mm longueur 4.4, 5 et 6m.",
    category: "lames_rideaux",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Épaisseur: 0.7, 0.8 et 1mm",
      "Hauteur de lame: 115 mm",
      "Longueur: 4.4, 5 et 6m",
      "Traitement anticorrosion"
    ]
  },
  {
    id: "lame-rideau-plane",
    title: "Lame rideau plane",
    image: "/assets/images/products/Lame rideau plane.webp",
    description: "Lame plate pour rideaux métalliques compacts",
    longDescription: "Disponibles en différentes épaisseurs 0.5, 0.6, 0.7, 0.8 et 1mm de longueur 4.4, 5, et 6m.",
    category: "lames_rideaux",
    specifications: [
      "Pour toute demande de personnalisation, consulter l'équipe technico-commerciale",
      "Épaisseur: 0.5, 0.6, 0.7, 0.8 et 1mm",
      "Longueur: 4.4, 5, et 6m",
      "Système d'emboîtement sécurisé",
      "Finition galvanisée ou laquée"
    ]
  },
  {
    id: "monorail",
    title: "Monorail",
    image: "/assets/images/products/Monorail.webp",
    description: "Rail de guidage supérieur pour portes suspendues",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de Monorail.",
    category: "lames_rideaux",
    specifications: [
      "Tableau de spécificités fourni avec détails sur la désignation, la matière et le poids",
      "Section en I ou en U selon applications",
      "Capacité de charge optimisée selon modèle",
      "Fixation plafond ou murale",
      "Compatible avec différents types de chariots roulants"
    ]
  },
  {
    id: "tube-rail",
    title: "Tube rail",
    image: "/assets/images/products/Tube rail.webp",
    description: "Rail tubulaire pour systèmes de portes coulissantes",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de Tube rail.",
    category: "lames_rideaux",
    specifications: [
      "Tableau de spécificités:",
      "- Tube Rail à Visser 3: Galvanisé 6, 8.928 kg",
      "- Tube Rail à sceller 3: Galvanisé 6, 22.752 kg",
      "Supports de fixation disponibles",
      "Finition lisse pour réduire l'usure des galets"
    ]
  }
];

export default lamesRideaux;
